export const USER_TYPE_ALL = 'all';
export const USER_TYPE_TECHNICIANS = 'technicians';
